






































































import {
	BaseTLComponent, Component, EmploymentFilter, EnumsService, EnumsFilter, Prop, tlLogDebugString
} from "../../../Infrastructure/CorBase/CoreBase";

@Component
export default class SubstituteList extends BaseTLComponent {

	Employment: any[] = [];
	selectedEmployeeId: number = 0;
	_enumsService: EnumsService = new EnumsService();
	//_operationalDispatchingService: OperationalDispatchingService = new OperationalDispatchingService();
	//workingGroupService: WorkingGroupService = new WorkingGroupService();
	@Prop({ type: Boolean, required: false, default: false }) isShowModal?: boolean; //zobrazení v modálním dialogu
	@Prop({ type: String, required: false, default: "" }) idOperationalRecord?: string; //operational record ID

	selected: any[] = [];
	trainingItems: any[] = [];

	trainingText = '';


	inputWidth = "5";
	labelWidth = "4";
	workingGroupList: any[] = [];

	formData = {
		useSelectTraining: false,
		isConditions: true,
		isSubstitute: false,
		list: '',
		idTenant: 0,
		idWorkingGroup: 0,
		idOperationRecord: 0
	};

	//nastavení sloupcu tabulky
	fields = [
		//{ key: 'id', label: 'id empoly', sortable: true,  class: 'text-center' },
		{ key: 'idPersonNavigationPersonalNumber', label: 'Osobní číslo', sortable: true,  class: 'text-center' },
		{ key: 'idPersonNavigationLastname', label: 'Příjmení', sortable: true,  class: 'text-center' },
		{ key: 'idPersonNavigationFirstname', label: 'Jméno', sortable: true,  class: 'text-center' },
		{ key: 'idEmploymentTypeNavigationName', label: 'Druh pracovního poměru', sortable: true,  class: 'text-center' }
	];

	filters = [
		{ key: 'idPersonNavigationPersonalNumber', label: 'Osobní číslo', selected: false, value: null, type: 'text' },
		{ key: 'idPersonNavigationFirstname', label: 'Jméno', selected: false, value: null, type: 'text' },
		{ key: 'idPersonNavigationLastname', label: 'Příjmení', isDate: true, selected: false, value: null, type: 'text' },
	];


	created() {
		tlLogDebugString('SUBSTITUTE ');
		super.initializeRights('COR_Employee_Create', 'COR_Employee_Delete', 'COR_Employee_Read', 'COR_Employee_Update');

		//this._operationalDispatchingService = new OperationalDispatchingService();
		this._enumsService = new EnumsService();

		if (this.isShowModal == false) {
			this.fields.push({ key: 'actions', label: 'Volby', sortable: false,  class: 'text-center' });
		}
		this.formData.idOperationRecord = Number(this.idOperationalRecord);

		this.fetchWorkingGroup();
		this.fetchEmployment();
		this.initTrainings();
	};

	createNewEmployee(EmployeeId: any) {
		this.$router.push({ name: "EmployeeCreate", params: { id: EmployeeId, type: "new" } });
	};



	lastList = '';
	lastWorkingGroup = -1;
	lastIsSubstitute = false;
	lastIsConditions = true;

	changeFilters() {

		if (this.formData.useSelectTraining) {
			let listHelp = '';
			let trainingTextHelp = '';
			for (var i = 0; i < this.selected.length; i++) {
				let selectedId = this.selected[i];
				listHelp = listHelp + selectedId;
				trainingTextHelp = trainingTextHelp + this.trainingItems.find(item => item.value == selectedId).text;
				if (this.selected.length > i + 1) {
					listHelp = listHelp + '|';
					trainingTextHelp = trainingTextHelp + ', ';
				}
			}
			this.formData.list = listHelp;
			this.trainingText = trainingTextHelp;
		}
		else {
			this.formData.list = '';
			this.trainingText = '';
		}
		if (this.formData.list != this.lastList ||
			this.formData.idWorkingGroup != this.lastWorkingGroup ||
			this.formData.isConditions != this.lastIsConditions ||
			this.formData.isSubstitute != this.lastIsSubstitute
		) {

			this.lastList = this.formData.list;
			this.lastWorkingGroup = this.formData.idWorkingGroup;
			this.lastIsSubstitute = this.formData.isSubstitute;
			this.lastIsConditions = this.formData.isConditions
			this.fetchEmployment();
		}
	}

	getEmployments() {
		//this.changeFilters();
		return this.Employment;
	}


	detailEmployee(EmployeeId: any) {
		if (this.isShowModal) {

			this.$emit('selectItem', this.Employment.filter(c => c.id == EmployeeId)[0]);
		} else if (this.hasRight) {
			this.$router.push({ name: "EmployeeCreate", params: { id: EmployeeId, type: "detail" } });
		}
	};

	updateEmployee(EmployeeId: any) {
		this.$router.push({ name: 'EmployeeCreate', params: { id: EmployeeId, type: "update" } });
	};

	deleteEmployee(EmployeeId: any) {
		this.$router.push({ name: "EmployeeCreate", params: { id: EmployeeId, type: "delete" } });
	};

	changeWorkGroup(ev: any) {
		//VaPTODO - je to hnus, ale chce to predelat base tl input, aby fungovalo klasicke @change a dalsi
		this.formData.idWorkingGroup = ev.target.value;
		this.changeFilters();
	}

	fetchEmployment() {
		//let employmentFilter: EmploymentFilter = new EmploymentFilter(null, this.formData.idWorkingGroup, this.$store.state.idTenant, Number(this.idOperationalRecord), this.formData.isConditions, this.formData.isSubstitute, this.formData.list, true);
		//this._operationalDispatchingService.getSubstitute(employmentFilter).then((response) => {

		//	this.Employment = response.data;
		//}).catch((rest) => {
		//});

	}

	//nacteni turnusů
	fetchWorkingGroup() {
		//let workingGroupFilter: WorkingGroupFilter;
		//if (this.isOwnerPage && !this.hasRight) {
		//	//VaPTODO - docist data pro majitele, ktery nema jinak prava na zobrazeni kalendare, takze ma videt pouze sve zaznamy
		//	//        - majitel je this.idPerson
		//	workingGroupFilter = new WorkingGroupFilter(this.$store.state.idTenant, false);
		//}
		//else {
		//	workingGroupFilter = new WorkingGroupFilter(this.$store.state.idTenant, false);
		//}
		//this.workingGroupService.getAllByFilter(workingGroupFilter).then((response) => {
		//	this.workingGroupList = [];
		//	for (var i = 0; i < response.data.length; i++) {
		//		this.workingGroupList.push({ value: response.data[i].id, text: response.data[i].name });
		//	}
		//});
	}

	disableSubstitute(): boolean {
		return this.formData.idWorkingGroup <= 0;
	}

	options() {
		return this.trainingItems;
	}

	//nacteni kurzů
	initTrainings() {
		let enumsFilter: EnumsFilter = new EnumsFilter(this.$store.state.idTenant, 'ENU_COR_Training_TrainingType', false);
		this._enumsService.getAllByFilter(enumsFilter).then((response) => {
			this.trainingItems = [];
			for (var i = 0; i < response.data.length; i++) {
				this.trainingItems.push({ value: response.data[i].id, text: response.data[i].description });
			}

		}).catch((res) => {
		});


	}
};
